import { render, staticRenderFns } from "./AddTransportation.vue?vue&type=template&id=629aa9ab"
import script from "./AddTransportation.vue?vue&type=script&lang=js"
export * from "./AddTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports